/* eslint-disable @stylistic/jsx-indent */
/* eslint-disable @stylistic/indent */
import Popup from "reactjs-popup";
import React, { useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import Button from "../Parts/Button";
import PowerShadesTypeahead from "../Parts/PowerShadesTypeahead";
import store from "../Store";
import { updateAssembly, InitialAssemblyState, InitialShadeState, updateAssemblies } from "../Store/entities/assemblies";
import { useAssembliesByQuoteId, UseAssembly } from "../Store/entities/assemblies/hooks";

import { useQuoteById, useQuoteIdAndDispatch, useQuoteTypeNameByQuoteId } from "../Store/entities/quotes/hooks";
import InfoBox from "./ShadeForm/InfoBox";
import PriceErrors from "./PriceErrors";
import apiCalls from "../PowerShadesAPIFunctions";
import { useNewIndoorShadeOptions } from "../Store/entities/assemblies/IndoorHooks.ts";
import { AssemblyStore, IndoorShadeOptionsDict, IndoorManualChain, IndoorMotorType, IndoorShadeOptionsDualDict, IndoorShadeOptionsSingleDict, IndoorDriveType, IndoorShadeConfiguration, IndoorEndCaps, IndoorHardwareColor, AssemblyViewModelFromAssemblyStore, IndoorHeaderType, IndoorMountType, IndoorShadeOptionsCoupledDict, PortalShadeOption } from "../Store/entities/assemblies/types";
import FractionField from "./NewOptionFields/FractionField";
import CoupledShadeTable from "./NewItems/CoupledShadeTable";
import { ErrorSet, useAssemblyErrorsByStore } from "../Store/entities/assemblies/errors/hooks";
import ImageToolTip from "./ImageTooltip";
import { useQuoteCombination } from "../Store/entities/combinations/hooks";
import { initialQuote } from "../Store/entities/quotes";
import FabricSelectField from "./NewOptionFields/FabricSelectField";
import { useIndoorFabrics } from "../Store/entities/hooks";
import { useUser } from "../Store/user/hooks";

type EditIndoorShadeModalProps = {
    isOpen: boolean;
    onClose: () => void;
    quoteId: number;
    sequenceId: number;
    sequenceIds?: number[];
    massEdit?: boolean | undefined;
};
type EditIndoorShadeModalBaseProps = {
    isOpen: boolean;
    onClose: () => void;
    quoteId: number;
    assembly: AssemblyStore;
    setAssembly: (assembly: AssemblyStore) => void;
    isNotAdd?: boolean;
    massEdit?: boolean | undefined;
};

type EditIndoorShadeModalBaseInnerProps = {
    options: IndoorShadeOptionsDict;
    quoteType: string;
    isNotAdd?: boolean;
    massEdit?: boolean | undefined;
    unlocked?: boolean;
    errors?: ErrorSet[];
};

const EditIndoorShadeModalInner = ({ options, quoteType, unlocked = true, errors = [] }: EditIndoorShadeModalBaseInnerProps) => {
    const {
        Height,
        HeaderMountType,
        ControlSide,
        HeaderType,
        RoomName,
        ShadeName,
        DirectionFacing,
        Floor,
        ShadeConfiguration,
        DriveType,
        TotalWidth,
        MotorType,
        ManualType,
        EndCaps,
        HardwareColor,
        SideChannels,
        SideChannelsColor,
        HembarType,
        WindowJambDepth,
        ManualChainColor,
        LVPowerSupply
    } = options;

    const disabled = !unlocked;

    const groupHeader = (groupName: string) => (
        <Row className={`form-group-title text-center m-2 text-green border-success border-bottom text-${quoteType}`}>
            <Col>
                {groupName}
            </Col>
        </Row>
    );

    const optionLabel = (option: PortalShadeOption<any>) => {
        const { label } = option;

        return (

            <Row className="text-center mb-1 px-3" xs={12}>
                {
                    // Only show icon and tooltip with these labels
                    option.valuePopup
                        ? <div className="d-flex justify-content-center position-relative z-2">
                            <label className="w-100">
                                {label}
                            </label>
                            <ImageToolTip option={option} label={label} />
                        </div>
                        : <label>{label}</label>
                }

            </Row>
        );
    };

    const optionFooter = (option: PortalShadeOption<any>) => {
        const {
            info,
            label
        } = option;

        if (!info || info.length == 0) return null;

        return (
            <Row className="text-center mb-1" xs={12}>
                {
                    info && info.length > 0 && (
                        <InfoBox quoteType={quoteType} key={`info-box-${label}`} message={info} />
                    )
                }
            </Row>
        );
    };

    const isMotorized = DriveType.getValue() === "motorized";
    const driveOption = isMotorized ? MotorType : ManualType;
    type driveOptionType = (IndoorManualChain | IndoorMotorType);

    const isDual = ShadeConfiguration.getValue() === "dual" || ShadeConfiguration.getValue() === "dual coupled";
    const isCoupled = ShadeConfiguration.getValue() === "single coupled" || ShadeConfiguration.getValue() === "dual coupled";

    const innerRollDirectionOption = isDual ? (options as IndoorShadeOptionsDualDict).FrontRollDirection : (options as IndoorShadeOptionsSingleDict).RollDirection;
    const outerRollDirectionOption = (options as IndoorShadeOptionsDualDict).BackRollDirection;

    const innerFabric = isDual ? (options as IndoorShadeOptionsDualDict).FrontFabric : (options as IndoorShadeOptionsSingleDict).Fabric;
    const outerFabric = (options as IndoorShadeOptionsDualDict).BackFabric;

    // Filter and sort
    const onlyActive = (options: (any | undefined)) => (options?.filter((option) => option.isActive ?? true)?.sort((o1, o2) => o1.value.localeCompare(o2.value)) ?? []) as { value: string }[];

    const erroredClass = "border border-danger";

    const errorClass = (option: PortalShadeOption<any>) => (errors.find((error) => error.varName === option?.varName) ? erroredClass : "");

    const fasciaSplit = (options as IndoorShadeOptionsCoupledDict).FasciaSplit;

    return (
        <Row>
            <Col>
                <Row>
                    <Col key="form-group-header">
                        {groupHeader("Motor")}
                        <Row className="p-2">
                            <Col>
                                {optionLabel(DriveType)}
                                <PowerShadesTypeahead
                                    disabled={disabled}
                                    id="header-mount-type"
                                    options={onlyActive(DriveType.options) ?? []}
                                    onChange={(selected) => {
                                        if (selected.length === 0) {
                                            DriveType.clearValue();
                                            return;
                                        }
                                         const selectedObj = selected[0] as {
                                            value: IndoorDriveType;
                                        };

                                        DriveType.setValue(selectedObj.value);
                                    }}
                                    selected={[DriveType.getSelectedOption()]}
                                />
                                {optionFooter(DriveType)}
                            </Col>
                            <Col>
                                {optionLabel(driveOption)}
                                <PowerShadesTypeahead
                                    disabled={disabled}
                                    id="header-mount-type"
                                    options={onlyActive(driveOption.options) ?? []}
                                    onChange={(selected) => {
                                        if (selected.length === 0) {
                                            driveOption.clearValue();
                                            return;
                                        }
                                        const selectedObj = selected[0] as {
                                            value: driveOptionType;
                                        };

                                        driveOption.setValue(selectedObj.value as never);
                                    }}
                                    selected={[driveOption.getSelectedOption()]}
                                    errored={errorClass(driveOption) !== ""}
                                />
                                {optionFooter(driveOption)}
                            </Col>
                        </Row>
                        <Row className="p-2">
                            <Col xs={6}>
                                {optionLabel(TotalWidth)}
                                    <FractionField
                                        extraClasses={` ${errorClass(TotalWidth)}`}
                                        key="total-width-edit"
                                        disabled={disabled}
                                        onBlur={(value) => TotalWidth.setValue(value)}
                                        value={TotalWidth.getValue()}
                                        minValue={TotalWidth.minValue ?? 0}
                                        maxValue={TotalWidth.maxValue ?? 0}
                                        varName="total_width"
                                    />
                                {optionFooter(TotalWidth)}
                            </Col>
                            <Col>
                                {optionLabel(Height)}
                                    <FractionField
                                        extraClasses={` ${errorClass(Height)}`}
                                        key="height-edit"
                                        disabled={disabled}
                                        onBlur={(value) => Height.setValue(value)}
                                        value={Height.getValue()}
                                        minValue={Height.minValue ?? 0}
                                        maxValue={Height.maxValue ?? 0}
                                        varName="height"

                                    />
                                {optionFooter(Height)}
                            </Col>
                        </Row>
                        <Row className="p-2">
                            <Col>
                                {optionLabel(HeaderMountType)}
                                <PowerShadesTypeahead
                                    disabled={disabled}
                                    id="header-mount-type"
                                    options={onlyActive(HeaderMountType.options)}
                                    onChange={(selected) => {
                                        if (selected.length === 0) {
                                            HeaderMountType.clearValue();
                                            return;
                                        }
                                        const selectedObj = selected[0] as {
                                            value: IndoorMountType;
                                        };

                                        HeaderMountType.setValue(selectedObj.value);
                                    }}
                                    selected={[HeaderMountType.getSelectedOption()]}
                                    errored={errorClass(HeaderMountType) !== ""}
                                />
                                {optionFooter(HeaderMountType)}
                            </Col>
                            <Col>
                                {optionLabel(ShadeConfiguration)}
                                <PowerShadesTypeahead
                                    disabled={disabled}
                                    id="header-type"
                                    options={onlyActive(ShadeConfiguration.options) ?? []}
                                    onChange={(selected) => {
                                        if (selected.length === 0) {
                                            ShadeConfiguration.clearValue();
                                            return;
                                        }
                                        const selectedObj = selected[0] as {
                                            value: IndoorShadeConfiguration;
                                        };

                                        ShadeConfiguration.setValue(selectedObj.value);
                                    }}
                                    selected={[ShadeConfiguration.getSelectedOption()]}
                                    errored={errorClass(ShadeConfiguration) !== ""}
                                />
                                {optionFooter(ShadeConfiguration)}

                            </Col>
                        </Row>
                    </Col>
                </Row>
                {
                    isCoupled && (
                        <Row>
                            <Col
                                key="form-group-sizes"
                                className={`no-bottom header `}
                            >
                                {groupHeader("Coupled Shades")}
                                <CoupledShadeTable
                                    widthsOption={(options as IndoorShadeOptionsCoupledDict).CoupledWidth}
                                    bandCountOption={(options as IndoorShadeOptionsCoupledDict).BandCount}
                                    disabled={disabled}
                                />

                            </Col>

                        </Row>
                    )
                }
                <Row>
                    <Col
                        key="form-group-sizes"
                        className="no-bottom header"
                    >
                            {groupHeader("Roll Direction")}
                        <Row className="p-2">
                            <Col>
                                {optionLabel(innerRollDirectionOption)}
                                <PowerShadesTypeahead
                                    disabled={disabled}
                                    id="inner-roll-direction"
                                    options={onlyActive(innerRollDirectionOption.options) ?? []}
                                    onChange={(selected) => {
                                        if (selected.length === 0) {
                                            innerRollDirectionOption.clearValue();
                                            return;
                                        }
                                        const selectedObj = selected[0] as {
                                            value;
                                        };

                                        innerRollDirectionOption.setValue(selectedObj.value);
                                    }}
                                    selected={[innerRollDirectionOption.getSelectedOption()]}
                                    clearButton={innerRollDirectionOption.getSelectedOption().label !== ""}
                                    errored={errorClass(innerRollDirectionOption) !== ""}
                                />
                                {optionFooter(innerRollDirectionOption)}
                            </Col>
                            {isDual ? <Col>
                                {optionLabel(outerRollDirectionOption)}
                                <PowerShadesTypeahead
                                    disabled={disabled}
                                    id="outer-roll-direction"
                                    options={onlyActive(outerRollDirectionOption.options)}
                                    onChange={(selected) => {
                                        if (selected.length === 0) {
                                            outerRollDirectionOption.clearValue();
                                            return;
                                        }
                                        const selectedObj = selected[0] as {
                                            value;
                                        };

                                        outerRollDirectionOption.setValue(selectedObj.value);
                                    }}
                                    selected={[outerRollDirectionOption.getSelectedOption()]}
                                    clearButton={outerRollDirectionOption.getSelectedOption().label !== ""}
                                    errored={errorClass(outerRollDirectionOption) !== ""}
                                />
                                {optionFooter(outerRollDirectionOption)}

                            </Col> : <Col />}
                        </Row>
                    </Col>
                </Row>
                    {groupHeader("Header")}
                <Row className="p-2">
                    <Col >
                        {optionLabel(HeaderType)}
                        <PowerShadesTypeahead
                            disabled={disabled}
                            id="color"
                            options={onlyActive(HeaderType.options)}
                            onChange={(selected) => {
                                if (selected.length === 0) {
                                    HeaderType.clearValue();
                                    return;
                                }
                                const selectedObj = selected[0] as {
                                    value: IndoorHeaderType;
                                };
                                HeaderType.setValue(selectedObj.value);
                            }}
                            selected={[HeaderType.getSelectedOption()]}
                            errored={errorClass(HeaderType) !== ""}
                        />
                        {optionFooter(HeaderType)}
                    </Col>
                   
                </Row>
                <Row>
                {EndCaps.active && <Col xs={6}>
                        {optionLabel(EndCaps)}
                        <PowerShadesTypeahead
                            disabled={disabled}
                            id="fabric"
                            options={onlyActive(EndCaps.options) ?? []}
                            onChange={(selected) => {
                                if (selected.length === 0) {
                                    EndCaps.clearValue();
                                    return;
                                }
                                const selectedFabric = selected[0] as {
                                    value: IndoorEndCaps;
                                };
                                EndCaps.setValue(selectedFabric.value);
                            }}
                            selected={[EndCaps.getSelectedOption()]}
                            errored={errorClass(EndCaps) !== ""}
                        />
                        {optionFooter(EndCaps)}
                    </Col>}
                    {HardwareColor.active && <Col xs={6} className="pt-2">
                        {optionLabel(HardwareColor)}
                        <PowerShadesTypeahead
                            disabled={disabled}
                            id="hardware_color"
                            options={onlyActive(HardwareColor.options)}
                            onChange={(selected) => {
                                if (selected.length === 0) {
                                    HardwareColor.clearValue();
                                    return;
                                }

                                const selectedObj = selected[0] as {
                                    value: IndoorHardwareColor;
                                };

                                HardwareColor.setValue(selectedObj.value);
                            }}
                            selected={[HardwareColor.getSelectedOption()]}
                            errored={errorClass(HardwareColor) !== ""}
                        />
                        {optionFooter(HardwareColor)}
                    </Col>}
                </Row>
                    {groupHeader("Fabric Select")}
                <Row className="p-2">
                    <Col>
                        <Row>
                            <Col className="text-center">
                            {optionLabel(innerFabric)}
                            <FabricSelectField
                                id="dropdown-full"
                                className="text-center"
                                disabled={disabled}
                                value={innerFabric.getValue() ?? ""}
                                choices={innerFabric.options}
                                canceled={innerFabric.clearValue}
                                onChange={(newFabricName) => {
                                    newFabricName
                                    ? innerFabric.setValue(newFabricName)
                                    : innerFabric.clearValue();
                                }}
                                onBlur={() => {
                                    console.log("blur");
                                }}
                            />
                            {optionFooter(innerFabric)}
                            </Col>
                        </Row>
                        <Row className="pt-2">
                            {isDual && <Col>
                                {optionLabel(outerFabric)}
                                    <FabricSelectField
                                        id="dropdown-full"
                                        clearButton
                                        disabled={disabled}
                                        value={outerFabric.getValue() ?? ""}
                                        choices={outerFabric.options}
                                        canceled={outerFabric.clearValue}
                                        onChange={(newFabricName) => {
                                            newFabricName
                                            ? outerFabric.setValue(newFabricName)
                                            : outerFabric.clearValue();
                                        }}
                                        onBlur={() => {
                                            console.log("blur");
                                        }}
                                        selected={[outerFabric.getSelectedOption()]}
                                        errored={errorClass(outerFabric) !== ""}
                                    />
                                {optionFooter(outerFabric)}
                            </Col>}
                        </Row>

                    </Col>

                </Row>
                    {groupHeader("Motor Options")}
                <Row className="p-2">
                    <Col
                        key="form-group-sizes"
                        className={` no-bottom header `}
                    >
                        <Row>
                            <Col>
                                {optionLabel(ControlSide)}
                                <PowerShadesTypeahead
                                    disabled={disabled}
                                    id="header-type"
                                    options={onlyActive(ControlSide.options) ?? []}
                                    onChange={(selected) => {
                                        if (selected.length === 0) {
                                            ControlSide.clearValue();
                                            return;
                                        }
                                        const selectedObj = selected[0] as {
                                            value;
                                        };

                                        ControlSide.setValue(selectedObj.value);
                                    }}
                                    selected={[ControlSide.getSelectedOption()]}
                                    errored={errorClass(ControlSide) !== ""}
                                />
                                {optionFooter(ControlSide)}
                            </Col>
                            <Col>
                                {optionLabel(HembarType)}
                                <PowerShadesTypeahead
                                    disabled={disabled}
                                    id="hembar-type"
                                    options={onlyActive(HembarType.options) ?? []}
                                    onChange={(selected) => {
                                        if (selected.length === 0) {
                                            HembarType.clearValue();
                                            return;
                                        }
                                        const selectedObj = selected[0] as {
                                            value;
                                        };

                                        HembarType.setValue(selectedObj.value);
                                    }}
                                    selected={[HembarType.getSelectedOption()]}
                                    errored={errorClass(HembarType) !== ""}
                                />
                                {optionFooter(HembarType)}
                            </Col>

                        </Row>
                        { WindowJambDepth.active && <Row className="pt-2">
                            <Col>
                                {optionLabel(WindowJambDepth)}
                                    <FractionField
                                        key="window_jamb_depth"
                                        disabled={disabled}
                                        onBlur={(value) => WindowJambDepth.setValue(value)}
                                        value={WindowJambDepth.getValue()}
                                        minValue={WindowJambDepth.minValue ?? 0}
                                        maxValue={WindowJambDepth.maxValue ?? 0}
                                        varName="window_jamb_depth"
                                        extraClasses={` ${errorClass(WindowJambDepth)}`}
                                    />
                                {optionFooter(WindowJambDepth)}
                            </Col>
                            <Col />
                        </Row>}
                    </Col>

                </Row>
                    {(SideChannels.active || ManualChainColor.active) && groupHeader("Options")}
                <Row className="p-2">
                    <Col
                        key="form-group-header"
                        className={` no-bottom header `}
                    >
                        {SideChannels.active && <Row>
                            <Col xs={6}>
                                {optionLabel(SideChannels)}
                                <PowerShadesTypeahead
                                    disabled={disabled}
                                    id="header-type"
                                    options={onlyActive(SideChannels.options) ?? []}
                                    onChange={(selected) => {
                                        if (selected.length === 0) {
                                            SideChannels.clearValue();
                                            return;
                                        }
                                        const selectedObj = selected[0] as {
                                            value;
                                        };

                                        SideChannels.setValue(selectedObj.value);
                                    }}
                                    selected={[SideChannels.getSelectedOption()]}
                                    errored={errorClass(SideChannels) !== ""}
                                />
                                {optionFooter(SideChannels)}
                            </Col>
                            {SideChannelsColor.active && <Col>
                                {optionLabel(SideChannelsColor)}
                                <PowerShadesTypeahead
                                    disabled={disabled}
                                    id="header-type"
                                    options={onlyActive(SideChannelsColor.options) ?? []}
                                    onChange={(selected) => {
                                        if (selected.length === 0) {
                                            SideChannelsColor.clearValue();
                                            return;
                                        }
                                        const selectedObj = selected[0] as {
                                            value;
                                        };

                                        SideChannelsColor.setValue(selectedObj.value);
                                    }}
                                    selected={[SideChannelsColor.getSelectedOption()]}
                                    errored={errorClass(SideChannelsColor) !== ""}
                                />
                                {optionFooter(SideChannelsColor)}
                            </Col>}

                        </Row>}

                        {ManualChainColor.active
                            && <Row>
                                    <Col c>
                                        {optionLabel(ManualChainColor)}
                                        <PowerShadesTypeahead
                                            disabled={disabled}
                                            id="header-type"
                                            options={onlyActive(ManualChainColor.options) ?? []}
                                            onChange={(selected) => {
                                                if (selected.length === 0) {
                                                    ManualChainColor.clearValue();
                                                    return;
                                                }
                                                const selectedObj = selected[0] as {
                                                    value;
                                                };

                                            ManualChainColor.setValue(selectedObj.value);
                                        }}
                                        selected={[ManualChainColor.getSelectedOption()]}
                                        errored={errorClass(ManualChainColor) !== ""}
                                        />
                                    {optionFooter(ManualChainColor)}
                                    </Col>
                                </Row>}

                            {LVPowerSupply.active
                            && <Col>
                                    {optionLabel(LVPowerSupply)}
                                    <PowerShadesTypeahead
                                        disabled={disabled}
                                        id="header-type"
                                        options={onlyActive(LVPowerSupply.options) ?? []}
                                        onChange={(selected) => {
                                            if (selected.length === 0) {
                                                LVPowerSupply.clearValue();
                                                return;
                                            }
                                            const selectedObj = selected[0] as {
                                                value;
                                            };

                                            LVPowerSupply.setValue(selectedObj.value);
                                        }}
                                        selected={[LVPowerSupply.getSelectedOption()]}
                                        className={`text-center p-2`}
                                        errored={errorClass(LVPowerSupply) !== ""}
                                    />
                                    {optionFooter(LVPowerSupply)}
                                </Col>

                            }
                            {fasciaSplit && fasciaSplit.active
                            && <Row>
                                    <Col c>
                                        {optionLabel(fasciaSplit)}
                                        <PowerShadesTypeahead
                                            disabled={disabled}
                                            id="header-type"
                                            options={onlyActive(fasciaSplit.options) ?? []}
                                            onChange={(selected) => {
                                                if (selected.length === 0) {
                                                    fasciaSplit.clearValue();
                                                    return;
                                                }
                                                const selectedObj = selected[0] as {
                                                    value;
                                                };

                                                fasciaSplit.setValue(selectedObj.value);
                                        }}
                                        selected={[fasciaSplit.getSelectedOption()]}
                                        errored={errorClass(fasciaSplit) !== ""}
                                        />
                                    {optionFooter(fasciaSplit)}
                                    </Col>
                                </Row>}
                    </Col>
                </Row>

                    {groupHeader("Attributes")}
                <Row className="p-2">

                    <Col>
                        {optionLabel(DirectionFacing)}
                        <PowerShadesTypeahead
                            id="direction-facing"
                            clearButton={!!DirectionFacing.getSelectedOption()}
                            options={onlyActive(DirectionFacing.options) ?? []}
                            onChange={(selected) => {
                                if (selected.length === 0) {
                                    DirectionFacing.clearValue();
                                    return;
                                }
                                const selectedObj = selected[0] as {
                                    value;
                                };

                                DirectionFacing.setValue(selectedObj.value);
                            }}
                            selected={[DirectionFacing.getSelectedOption()]}
                            errored={errorClass(DirectionFacing) !== ""}
                        />
                        {optionFooter(DirectionFacing)}
                    </Col>
                    <Col>
                        {optionLabel(Floor)}
                            <input
                                type="number"
                                className={`rounded input-group p-2 ${errorClass(Floor)}`}
                                value={Floor.getValue()}
                                onChange={(e) => Floor.setValue(Number(e.target.value))}
                            />
                        {optionFooter(Floor)}
                    </Col>
                </Row>
                <Row className="p-2">
                    <Col xs={6}>
                        {optionLabel(RoomName)}
                            <input
                                className={`rounded input-group p-2 ${errorClass(RoomName)}`}
                                type="text"
                                value={RoomName.getValue()}
                                onChange={(e) => RoomName.setValue(e.target.value)}
                            />
                        {optionFooter(RoomName)}
                    </Col>
                    <Col xs={6}>
                        {optionLabel(ShadeName)}
                            <input
                                className={`rounded input-group p-2 ${errorClass(ShadeName)}`}
                                disabled={disabled}
                                type="text"
                                value={ShadeName.getValue()}
                                onChange={(e) => ShadeName.setValue(e.target.value)}
                            />
                        {optionFooter(ShadeName)}
                    </Col>
                </Row>
                <Row className="text-center p-2" />
            </Col>
        </Row>
    );
};

const EditIndoorShadeModalBase = ({ isOpen, onClose, assembly: incomingAssembly, setAssembly: setAssemblyIncoming, isNotAdd = true, massEdit = false }: EditIndoorShadeModalBaseProps) => {
    const [assembly, setAssembly] = React.useState(incomingAssembly);
    const quoteId = assembly.quote_id ?? 0;

    const indoorFabrics = useIndoorFabrics();

    const user = useUser();
    const quote = useQuoteById(quoteId);

    const shadeOptions = useNewIndoorShadeOptions({ ...InitialAssemblyState(), ...assembly }, setAssembly, {fabrics: indoorFabrics, user, quote}, massEdit);

    const quoteType = useQuoteTypeNameByQuoteId(quoteId);

    useEffect(() => {
        setAssembly(incomingAssembly);
    }, [isOpen]);

    const submitShade = () => {
        setAssemblyIncoming(assembly);
        onClose();
    };

    const [msrp, setMsrp] = React.useState(assembly.msrp);
    const [errorsFromBackend, setErrors] = React.useState(assembly.error_messages ?? "");

    const quoteStore = useQuoteIdAndDispatch(quoteId);

    const assemblies = useAssembliesByQuoteId(quoteId);

    const quoteCombinations = useQuoteCombination(quoteId);

    const feErrors = useAssemblyErrorsByStore(assembly, quoteStore ?? initialQuote(), assemblies, quoteCombinations ?? { Fascias: [] }, shadeOptions);

    const errorList = [
        ...feErrors.map((error) => error.message),
        ...errorsFromBackend.split(",")
    ];

    // Grab errors, delete extra commas, and join them into a single string
    const errors = massEdit ? "" : errorList.filter((error) => error !== "").reduce((acc, error) => acc + error + " ", "").slice(0, -2);
    const feErrorsToSend = massEdit ? [] : feErrors;
    useEffect(() => {
        if (quoteId === 0 || !isOpen) return;
        apiCalls.calculateAssemblyPriceNew(AssemblyViewModelFromAssemblyStore(assembly), quoteId, "Indoor").then((res) => {
            setMsrp(res?.data?.msrp ?? 0);
            const errorMessage = res?.data?.errors;
            const errorMessageListAsOneString = errorMessage?.join(", ") ?? "";
            setErrors(errorMessageListAsOneString);
        });
    }, [assembly, isOpen]);

    if (!isOpen) return null;

    return (
        <Popup open={isOpen} onClose={onClose} className="mobile-modal p-2 m-2">
            <Row>
                {
                    isNotAdd
                        ? <h2>Edit Shade</h2>
                        : <h2>Add Shade</h2>
                }
            </Row>
            <EditIndoorShadeModalInner
                options={shadeOptions}
                quoteType={quoteType}
                isNotAdd={isNotAdd}
                massEdit={massEdit}
                unlocked={assembly.unlocked}
                errors={feErrorsToSend}
            />
            {
                isNotAdd && (
                    <PriceErrors quoteId={quoteId} msrp={errors.length == 0 ? msrp : 0} error_messages={errors ?? ""} assembly={assembly} />
                )
            }
            <Row className=" justify-content-center w-100 mb-1">
                <Button
                    className="col-lg-4"
                    onClick={(assembly.unlocked || !isNotAdd) ? submitShade : onClose}
                >
                    Done
                </Button>
            </Row>
            {
                (!assembly.unlocked && isNotAdd)
                    ? <Row className="justify-content-center w-100">
                        <Button className="col-lg-4" onClick={() => setAssembly({ ...assembly, unlocked: true })}>
                            <FontAwesomeIcon icon={faLock} />
                        </Button>
                    </Row>
                    : null
            }
        </Popup>
    );
};

const EditIndoorShadeModal = ({ isOpen, onClose, quoteId, sequenceId, sequenceIds }: EditIndoorShadeModalProps) => {
    const assy = UseAssembly(quoteId, sequenceIds?.length ? sequenceIds[0] as number : sequenceId);

    const setAssembly = (assembly: AssemblyStore) => {
        sequenceIds
            ? sequenceIds.map((id) => {
                const newAssembly: AssemblyStore = { ...assembly, sequence_id: id };
                return store.dispatch(updateAssembly({ quoteId, assembly: newAssembly, sequenceId: id }));
            })
            : store.dispatch(updateAssembly({ quoteId, assembly, sequenceId }));
    };
    if (!assy) return null;
    return (
        <EditIndoorShadeModalBase
            isOpen={isOpen}
            onClose={onClose}
            quoteId={quoteId}
            assembly={assy}
            setAssembly={setAssembly}
        />
    );
};

type MassEditIndoorModalProps = {
    quoteId: number;
    isOpen: boolean;
    onClose: () => void;
};

const MassEditIndoorModal = ({ quoteId, isOpen, onClose }: MassEditIndoorModalProps) => {
    const assembly = { ...InitialAssemblyState(), unlocked: true, shades: [InitialShadeState()], quote_id: quoteId };
    let selectedAssemblies = useAssembliesByQuoteId(quoteId).filter((assy) => assy.selected);

    const setAssembly = (assy) => {
        Object.entries(assembly).forEach(([key, value]) => {
            if (key === "shades") {
                Object.entries(value[0]).forEach(([shadeKey, shadeVal]) => {
                    if (shadeVal !== assy.shades[0][shadeKey]) {
                        selectedAssemblies = selectedAssemblies.map((selectedAssy) => (
                            {
                                ...selectedAssy, shades: selectedAssy.shades.map((selectedShade) => (
                                    { ...selectedShade, [shadeKey]: assy.shades[0][shadeKey] }
                                ))
                            }
                        ));
                    }
                });
            }
            if (assy[key] !== value && key !== 'shades') {
                selectedAssemblies = selectedAssemblies.map((selectedAssy) => ({ ...selectedAssy, [key]: assy[key] }));
            }
        });
        store.dispatch(updateAssemblies({
            quoteId,
            assemblies: selectedAssemblies
        }));
    };

    return <EditIndoorShadeModalBase
        isOpen={isOpen}
        onClose={onClose}
        quoteId={quoteId}
        assembly={assembly}
        setAssembly={setAssembly}
        massEdit
    />;
};

export default EditIndoorShadeModal;

export {
    EditIndoorShadeModalBase,
    EditIndoorShadeModalInner,
    MassEditIndoorModal
};
